var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95429 31.0457 0 20 0C8.95429 0 0 8.95429 0 20C0 31.0457 8.95429 40 20 40Z",
    fill: "#DEF6FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6191 16.5596L23.0064 26.6784M11.3484 13.3351H28.6515H11.3484ZM27.3273 13.3351L25.8431 29.4846H14.3098L12.8258 13.3351H27.3273ZM16.5339 13.3351L17.5863 10.5153H22.5667L23.6191 13.3351H16.5339ZM20.0765 16.5263V26.6451V16.5263ZM16.5338 16.5596L17.1466 26.6784L16.5338 16.5596Z",
    stroke: "#0C6CDE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.663c2f12e9daf943be4bf3fbbfceac9b.svg";
export { ForwardRef as ReactComponent };